'use client';

import type {ProductImageLinkProps as Props} from './typings';

import Image from '@/atoms/Image/Image';
import {StyledBundleLink} from './styles';

const ProductImageLink = ({
  linkHref,
  linkTitle,
  imagePath,
  imageAlt,
  handleClick,
}: Props): JSX.Element => (
  <StyledBundleLink
    href={linkHref}
    title={linkTitle}
    aria-label={linkTitle}
    target="_blank"
    rel="noopener noreferrer"
    onClick={handleClick}
    tabIndex={0}
  >
    <Image path={imagePath} alt={imageAlt} width={200} height={200} retina />
  </StyledBundleLink>
);

export default ProductImageLink;
